export default "__VITE_ASSET__Xn7gtodb__"